import { SyncPoints } from "../store/player/types";

export const videoToMatchTime = (time: number, syncPoints: SyncPoints[]): string => {
    if (!syncPoints || syncPoints.length === 0) {
        const totalSeconds = Math.floor(time);
        const fmt = (v: number) => v.toString().padStart(2, '0');
        return `${fmt(Math.floor(totalSeconds / 60))}:${fmt(totalSeconds % 60)}`;
    }
    const syncPointsOrdered = [...syncPoints].sort((a, b) => b.time - a.time);
    const syncPoint = syncPointsOrdered.find((x) => x.time <= time) || syncPointsOrdered[syncPointsOrdered.length - 1];
    const timeIntoPeriod = Math.max(time - syncPoint.time, 0);
    const seconds = Math.trunc(timeIntoPeriod % 60);
    const minutes = Math.min(
        Math.floor((syncPoint.start + timeIntoPeriod - seconds) / 60),
        Math.floor((syncPoint.start + syncPoint.duration) / 60),
    );
    const minutesIntoPeriod = Math.floor((timeIntoPeriod - seconds) / 60);
    const addedTime = minutesIntoPeriod >= Math.floor(syncPoint.duration / 60);
    const addedMinutes = minutesIntoPeriod - Math.min(minutesIntoPeriod, Math.floor(syncPoint.duration / 60));
    const fmt = (v: number) => v.toString().padStart(2, '0');
    return `${fmt(minutes)}${addedTime ? `+${fmt(addedMinutes)}` : ''}:${fmt(seconds)}`;
};
